import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;

  gap: 0.325rem;

  @media (max-width: 600px) {
    flex-direction: row;
  }
`;

export const ImageLink = styled.a`
  transition: filter 0.2s;

  &:hover {
    filter: brightness(1.1);
  }
`;

export const StoreLogo = styled.img`
  max-height: 3.125rem;
  background: transparent;
`;
